import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Nav, NavItem, Card } from "react-bootstrap";
import "./SideNavigation.css";

export default function SideNavigationMenu(props) {
  const activeStyle = { 
    backgroundColor: "#005867", 
    color: "white",
    borderRadius: "4px"
  };
  
  return (
    <div className="side-nav-container">
      {/* Main Header Stripe */}
      <div className="side-nav-main-header">
        <h4 className="main-header-title">Options</h4>
      </div>
      
      {/* Main Navigation Section - without header */}
      <Card className="side-nav-card mb-3 mt-3">
        <Card.Body className="p-2">
          <Nav className="flex-column">
            <NavItem className="nav-item">
              <NavLink to="/options/myoptions" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                My Options
              </NavLink>
            </NavItem>
            <NavItem className="nav-item">
              <NavLink to="/options/faq" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                Frequently Asked Questions
              </NavLink>
            </NavItem>
          </Nav>
        </Card.Body>
      </Card>

      {/* Administration Section */}
      {props.isAdmin && !props.isGhost && (
        <Card className="side-nav-card mb-3">
          <Card.Body className="p-0">
            <div className="side-nav-section">
              <h5 className="side-nav-section-title">Administration</h5>
            </div>
            <Nav className="flex-column px-2 py-2">
              <NavItem className="nav-item">
                <NavLink to="/options/employees" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                  Employees
                </NavLink>
              </NavItem>
              <NavItem className="nav-item">
                <NavLink to="/options/plans/summary" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                  Plans
                </NavLink>
              </NavItem>
              <NavItem className="nav-item">
                <NavLink to="/options/stockprice" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                  Current Price
                </NavLink>
              </NavItem>
            </Nav>
          </Card.Body>
        </Card>
      )}
    </div>
  );
}

SideNavigationMenu.propTypes = {
  isAdmin: PropTypes.bool,
  isManager: PropTypes.bool,
  isGhost: PropTypes.bool
};